import styled from 'styled-components/macro';
import {
  BREAKPOINTS,
  COLORS,
  FLEX_CONTAINER,
  FONTS,
  FONT_FAMILY,
} from 'utils/styles';

export const CardAndDescriptionBlock = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  gap: 30px;
  margin-bottom: 52px;
`;

export const CardBlock = styled.div`
  width: 474px;
  padding-bottom: 10px;
  background: ${COLORS.darkYellow};
  border-radius: 10px;

  @media ${BREAKPOINTS.xl} {
    width: 400px;
  }

  @media ${BREAKPOINTS.md} {
    width: 306px;
  }
`;

export const CountryImage = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  background: url(${({ background }) => background});
  background-size: 100% 100%;
  border-radius: 10px 10px 0 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

export const TripDurationAndPrice = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  justify-content: center;
  position: absolute;
  width: 148px;
  height: 60px;
  background: ${COLORS.mainColor};
  border-top-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

export const TripDuration = styled.span`
  text-transform: capitalize;
  color: ${COLORS.white};
  ${FONTS.font14};
  ${FONT_FAMILY.FontRegular};
`;

export const PricePerPerson = styled.span`
  text-transform: capitalize;
  color: ${COLORS.white};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
`;

export const CardDescription = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn};
  ${COLORS.mainColor};
  align-items: flex-start;
  gap: 20px;
  width: 530px;
  height: 390px;

  p {
    overflow: hidden;
    padding: 10px 0;
  }

  @media ${BREAKPOINTS.xl} {
    width: 360px;
    height: 390px;
  }

  @media ${BREAKPOINTS.md} {
    display: none;
  }
`;

export const TripCountryAndPrice = styled.div`
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
  ${FLEX_CONTAINER.FlexColumn};
`;

export const CountryStarsPriceWrapper = styled.div`
  width: 100%;
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};
`;

export const DescriptionCard = styled.div`
  display: none;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  p {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    &:nth-child(1) {
      height: 198px;
    }
  }
  @media ${BREAKPOINTS.md} {
    display: block;
    width: 100%;
  }
`;

export const TripCountryAndStars = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn};
  align-items: unset;
`;

export const TripCountry = styled.span`
  ${FONTS.font20};
  line-height: 1.5;
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontMedium};
  margin-bottom: 12px;
`;

export const TripPrice = styled.span`
  ${FONTS.font28};
  color: ${COLORS.mainColor};
`;

export const DescriptionOfCard = styled.span``;

export const ReadMore = styled.span`
  color: ${COLORS.mainColor};
  cursor: pointer;
  display: ${({ isMedia }) => (isMedia ? 'none' : 'block')};

  @media only screen and ${BREAKPOINTS.md} {
    align-self: flex-start;
    display: ${({ isMedia }) => (isMedia ? 'block' : 'none')};
  }
`;

export const DescriptionContainer = styled.span`
  width: 360px;
  height: 180px;
  overflow: hidden;
  color: ${COLORS.mainColor};
  display: ${({ isMedia }) => (isMedia ? 'none' : 'block')};

  @media only screen and ${BREAKPOINTS.md} {
    width: 100%;
    display: ${({ isMedia }) => (isMedia ? 'block' : 'none')};
  }

  > p {
    display: -webkit-box;
    -webkit-line-clamp: 8;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 22px;
    text-overflow: ellipsis;
  }
`;
